import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Section from './Section';
import ReauthModal from './ReauthModal';
import SettingsNav from './SettingsNav';
import FormAlert from './FormAlert';
import SettingsGeneral from './SettingsGeneral';
import SettingsPassword from './SettingsPassword';
import SettingsBilling from './SettingsBilling';
import { useAuth } from '../util/auth';

function SettingsSection({ bg, textColor, size, bgImage, bgImageOpacity, section }) {
  const auth = useAuth();
  const [formAlert, setFormAlert] = useState(null);

  // State to control whether we show a re-authentication flow
  // Required by some security sensitive actions, such as changing password.
  const [reauthState, setReauthState] = useState({
    show: false
  });

  const validSections = {
    general: true,
    password: true,
    billing: true
  };

  const theSection = validSections[section] ? section : 'general';

  // Handle status of type "success", "error", or "requires-recent-login"
  // We don't treat "requires-recent-login" as an error as we handle it
  // gracefully by taking the user through a re-authentication flow.
  const handleStatus = ({ type, message, callback }) => {
    if (type === 'requires-recent-login') {
      // First clear any existing message
      setFormAlert(null);
      // Then update state to show re-authentication modal
      setReauthState({
        show: true,
        // Failed action to try again after reauth
        callback
      });
    } else {
      // Display message to user (type is success or error)
      setFormAlert({
        type,
        message
      });
    }
  };

  return (
    <Section
      bg={bg}
      textColor={textColor}
      size={size}
      bgImage={bgImage}
      bgImageOpacity={bgImageOpacity}
    >
      {reauthState.show && (
        <ReauthModal
          callback={reauthState.callback}
          provider={auth.user.providers[0]}
          onDone={() => setReauthState({ show: false })}
        />
      )}

      <SettingsNav activeKey={theSection} className="justify-content-center" />
      <Container
        className="mt-5"
        style={{
          maxWidth: '450px'
        }}
      >
        {formAlert && (
          <FormAlert
            type={formAlert.type}
            message={formAlert.message}
            className="mx-auto mb-4"
            style={{ maxWidth: '450px' }}
          />
        )}

        {theSection === 'general' && <SettingsGeneral onStatus={handleStatus} />}

        {theSection === 'password' && <SettingsPassword onStatus={handleStatus} />}

        {theSection === 'billing' && <SettingsBilling onStatus={handleStatus} />}
      </Container>
    </Section>
  );
}

SettingsSection.propTypes = {
  bg: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  bgImage: PropTypes.string.isRequired,
  bgImageOpacity: PropTypes.number.isRequired,
  section: PropTypes.string.isRequired
};

export default SettingsSection;
